export const ChangeLogItemType = {
    Feature: "feature",
    Fix: "fix",
    Improvement: "improvement",
} as const;
export type ChangeLogItemType = typeof ChangeLogItemType[keyof typeof ChangeLogItemType];

export interface ChangeLogVersion {
    buildLabel: string;
    date: string;
    items: ChangeLogItem[];
}

export interface ChangeLogItem {
    description: string;
    type?: ChangeLogItemType;
}
